module.exports = __webpack_public_path__ + "img/icon-timesheet.cab40883.svg";